
var id = "menuWxIcon";
var markup = "<symbol viewBox=\"0 0 46 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menuWxIcon\">\n<circle cx=\"23\" cy=\"21.6902\" r=\"11.3239\" fill=\"#F7F7F7\" stroke=\"#E5E5E5\" stroke-width=\"1.35211\" />\n<path d=\"M23.1689 6.30981L25.5351 8.67601H20.8027L23.1689 6.30981Z\" fill=\"#E5E5E5\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.7461 17.1267H19.1123V19.4929H16.7461V17.1267ZM16.7461 20.507H19.1123V22.8732H16.7461V20.507ZM22.4922 17.1267H20.126V19.4929H22.4922V17.1267ZM20.126 20.507H22.4922V22.8732H20.126V20.507ZM25.8732 17.1267H23.507V19.4929H25.8732V17.1267ZM23.507 20.507H25.8732V22.8732H23.507V20.507ZM29.2531 17.1267H26.8869V19.4929H29.2531V17.1267ZM26.8869 20.507H29.2531V22.8732H26.8869V20.507ZM26.5489 25.2394H19.7883V27.6056H26.5489V25.2394Z\" fill=\"#E5E5E5\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
